export const minglQrStickerSubject = 'Enquiry - Mingl Qr Sticker';

export const minglQrStickersBody = `Hi, \n \n
Thank you for reaching out to us about Mingl QR stickers.\n
Please specify the quantity of stickers and how many unique QRs you need.
We can print blank QRs too that any person can claim (great for gifting to a friend).
\n
Anyting else? Just ask!
\n
Regards
Team Mingl.`;

export const minglProSubject = 'Enquiry - Mingl Pro';
export const minglProBody = `Hi, \n \n
Thank you for interest in Mingl Pro, we have soultions for both companies and personal use. 
Send us any questions you have and we’ll be happy to answer them!
\n
Regards
Team Mingl.`;

export const minglCustomURLSubject = 'Enquiry - Custom URL';
export const minglCustomURLBody =
  `Hi, \n \n
Thank you for reaching out to us about custom URL's, please specify what you'd ` +
  `like your URL to look like. E.g www.mingl.no/superman.
 \n
 Anyting else? Just ask!
\n
Regards
Team Mingl.`;
